import { render, staticRenderFns } from "./RequestAlert.vue?vue&type=template&id=7f13e21f&"
import script from "./RequestAlert.vue?vue&type=script&lang=js&"
export * from "./RequestAlert.vue?vue&type=script&lang=js&"
import style0 from "./RequestAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports